import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "infocircleo",
  "use": "infocircleo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"infocircleo\"><title>infocirlceo</title><path d=\"M8 0Q5.828 0 3.984 1.07T1.07 3.984 0 8t1.07 4.016 2.914 2.914T8 16t4.016-1.07 2.914-2.914T16 8t-1.07-4.016-2.914-2.914T8 0zm4.859 12.859q-.953.953-2.188 1.469-1.266.547-2.672.547t-2.672-.531q-1.234-.531-2.188-1.484T1.67 10.672Q1.123 9.406 1.123 8t.531-2.672q.531-1.234 1.484-2.188t2.188-1.469q1.266-.547 2.672-.547t2.672.531q1.234.531 2.188 1.484t1.469 2.188q.547 1.266.547 2.672t-.531 2.672q-.531 1.234-1.484 2.188zm-3.015-1.828H8.516V5.562q0-.234-.164-.398T7.954 5h-1.5q-.234 0-.398.164t-.164.398q0 .219.164.391t.398.172h.938v4.906H6.064q-.234 0-.398.164t-.164.398q0 .234.164.398t.398.164h3.781q.234 0 .398-.164t.164-.398q0-.234-.164-.398t-.398-.164zM7.391 3.445q0-.227.164-.398t.398-.172.398.172.164.398-.164.391T7.953 4t-.398-.164-.164-.391z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/infocircleo.svg
// module id = 161
// module chunks = 0